import React from 'react';

const Footer = () => {
  return (
    <>
        <div className="footer-container flex flex-row justify-between p-6 text-2xl">
            <h1>@Copyright</h1>
            <h1>Devagya Rattan 2024</h1>
        </div>
    </>
  );
}

export default Footer;
